// import { useState } from "react";
// import {
//   TextField,
//   InputAdornment,
//   IconButton,
//   Popover,
//   Grid,
//   Button,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { CalendarIcon } from "../../../assets/svg/icons";

// const months = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// export default function CustomMonthYearPicker({
//   selectedMonth,
//   setSelectedMonth,
//   selectedYear,
//   setSelectedYear,
// }) {
//   const today = new Date();
//   const [anchorEl, setAnchorEl] = useState(null);

//   const handleOpen = (event) => setAnchorEl(event.currentTarget);
//   const handleClose = () => setAnchorEl(null);
//   const open = Boolean(anchorEl);

//   const handleMonthClick = (monthIndex) => {
//     setSelectedMonth(monthIndex);
//     handleClose();
//   };

//   const yearRange = Array.from(
//     { length: 11 },
//     (_, i) => today.getFullYear() - 10 + i
//   );

//   return (
//     <>
//       <TextField
//         // label="Start Date"
//         variant="outlined"
//         value={`${months[selectedMonth]} ${selectedYear}`}
//         InputLabelProps={{ shrink: true }}
//         InputProps={{
//           readOnly: true,
//           startAdornment: (
//             <InputAdornment position="start" >
//               <CalendarIcon width="17" height="17" />
//             </InputAdornment>
//           ),
//           endAdornment: (
//             <InputAdornment position="end" sx={{ m: 0 }}>
//               <IconButton onClick={handleOpen} size="small"
//           sx={{ p: 0, width: 10, height: 10 }}>
//                 <ArrowDropDownIcon />
//               </IconButton>
//             </InputAdornment>
//           ),
//         }}
//         sx={{
//           "& .MuiOutlinedInput-root": {
//             "& fieldset": {
//               border: "none",
//             },
//           },
//           "& .MuiInputBase-input": {
//             height: "0.2rem",
//             width: "5rem",
//             fontSize: "14px",
//             color: "gray"
//           },
//           backgroundColor: "#f7f5fa",
//           borderRadius: "8px",
//           alignSelf: "center"
//         }}
//       />

//       {/* Popup Month/Year Picker */}
//       <Popover
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "left",
//         }}
//         PaperProps={{
//           sx: {
//             borderRadius: "10px",
//             p: 1,
//           },
//         }}
//       >
//         {/* Year Selector */}
//         <Select
//           value={selectedYear}
//           onChange={(e) => setSelectedYear(e.target.value)}
//           fullWidth
//           sx={{ borderBottom: "1px solid #ddd" }}
//         >
//           {yearRange.map((year) => (
//             <MenuItem key={year} value={year}>
//               {year}
//             </MenuItem>
//           ))}
//         </Select>

//         {/* Month Grid */}
//         <Grid container spacing={1} sx={{ p: 2, width: 240 }}>
//           {months.map((month, idx) => {
//             const isDisabled =
//               selectedYear === today.getFullYear() && idx > today.getMonth();
//             return (
//               <Grid item xs={4} key={month}>
//                 <Button
//                   variant={idx === selectedMonth ? "contained" : "outlined"}
//                   size="small"
//                   fullWidth
//                   onClick={() => handleMonthClick(idx)}
//                   disabled={isDisabled}
//                 >
//                   {month}
//                 </Button>
//               </Grid>
//             );
//           })}
//         </Grid>
//       </Popover>
//     </>
//   );
// }

import { useState } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  Popover,
  Grid,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { CalendarIcon } from "../../../assets/svg/icons";
import { useTranslation } from "react-i18next";

export default function CustomMonthYearPicker({
  selectedMonth,
  setSelectedMonth,
  selectedYear,
  setSelectedYear,
}) {
  const today = new Date();
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const months = t("months", { returnObjects: true }); // array from translations

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  const handleMonthClick = (monthIndex) => {
    setSelectedMonth(monthIndex);
    handleClose();
  };

  const yearRange = Array.from(
    { length: 11 },
    (_, i) => today.getFullYear() - 10 + i
  );

  function convertToArabicNumerals(number) {
    const arabicDigits = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
    return number.toString().replace(/\d/g, (d) => arabicDigits[d]);
  }
  const displayYear = (year) =>
    i18n.language === "ar" ? convertToArabicNumerals(year) : year;

  return (
    <>
      <TextField
        variant="outlined"
        value={`${months[selectedMonth]} ${displayYear(selectedYear)}`}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          readOnly: true,
          startAdornment: (
            <InputAdornment position="start">
              <CalendarIcon width="17" height="17"/>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" sx={{ m: 0 }}>
              <IconButton
                onClick={handleOpen}
                size="small"
                sx={{ p: 0, width: 10, height: 10 }}
              >
                <ArrowDropDownIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "none",
            },
          },
          "& .MuiInputBase-input": {
            height: "0.2rem",
            width: "6rem",
            fontSize: "14px",
            color: "gray",
            paddingInlineEnd:"14px"
          },
          "& .MuiInputAdornment-root": {
            marginInlineEnd: "8px"
          },
          backgroundColor: "#f7f5fa",
          borderRadius: "8px",
          alignSelf: "center",
        }}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            borderRadius: "10px",
            p: 1,
          },
        }}
      >
        <Select
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          fullWidth
          sx={{ borderBottom: "1px solid #ddd" }}
        >
          {yearRange.map((year) => (
            <MenuItem key={year} value={year}>
              {displayYear(year)}
            </MenuItem>
          ))}
        </Select>

        <Grid container spacing={1} sx={{ p: 2, width: 240 }}>
          {months.map((month, idx) => {
            const isDisabled =
              selectedYear === today.getFullYear() && idx > today.getMonth();
            return (
              <Grid item xs={4} key={month}>
                <Button
                  variant={idx === selectedMonth ? "contained" : "outlined"}
                  size="small"
                  fullWidth
                  onClick={() => handleMonthClick(idx)}
                  disabled={isDisabled}
                >
                  {month}
                </Button>
              </Grid>
            );
          })}
        </Grid>
      </Popover>
    </>
  );
}
